import { Box, styled, Typography } from "@mui/material";

import { Message } from "fond/widgets";

export const GridContainer = styled(Box)(({ theme }) => ({
  height: 600,
  "& .ag-row.ag-row-group": { fontWeight: "bold" },
  "& .ag-row.ag-row-footer": { backgroundColor: theme.palette.action.hover },
  "& .ag-row:not(.ag-row-group) .ag-cell:first-of-type": { paddingLeft: 24 },
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const NoBomMessage = styled(Message)(({ theme }) => ({
  margin: `${theme.spacing(2)} ${theme.spacing(4)}`,
}));

export const SumBar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(4),
}));

export const SumBarTitle = styled(Typography)({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
});

export const SumBarTotal = styled(Typography)(({ theme }) => ({
  whiteSpace: "nowrap",
  marginRight: theme.spacing(1),
}));
